import { gql } from '@parkchirp/api-client';

export const CREATE_BULK_FEE_CHANGE = gql`
    mutation createBulkFeeChange(
        $s3Key: String!
    ) {
        createBulkFeeChange (
            s3Key: $s3Key
        ) {
            successfulFees,
            unsuccessfulFees,
            unsuccessfulCSVUrl,
        }
    }
`;
